import { Component, OnInit } from '@angular/core';
import { AuthState, logout } from '@emi/shared/state/auth';
import { Store } from '@ngrx/store';
import { LocalStorageValues } from '@emi/shared/constants';

@Component({
  selector: 'via-logout',
  templateUrl: './logout.component.html'
})
export class LogoutComponent implements OnInit {

  constructor(private store: Store<AuthState>) { }

  public ngOnInit(): void {
    localStorage.removeItem(LocalStorageValues.LOCAL_STORAGE_SID_KEY);
    this.store.dispatch(logout());
  }

}
